import AuthApi from './Auth';
import Base from './BaseApi';
import EventsApi from './Events';
import FavoritesApi from './Favorites';
import FilmsApi from './Films';
import OrdersApi from './Orders';
import PurchasesApi from './Purchases';
import VenuesApi from './Venues';

class Api extends Base {
    constructor(opts = {}) {
        super(opts);
        this.auth = new AuthApi(this);
        this.venues = new VenuesApi(this);
        this.films = new FilmsApi(this);
        this.events = new EventsApi(this);
        this.orders = new OrdersApi(this);
        this.favorites = new FavoritesApi(this);
        this.purchases = new PurchasesApi(this);
    }
}

export default Api;
